const ru = {
  downloadButtonLabel: 'Скачать PDF',
};

export default ru;
